import {Typography} from "@mui/material";
import {connect} from "react-redux";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
  }) => ({
    i18n,
    isLoading,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  return (
    <div className="card-service customer-service-text">
      <img src="../images/customerservice.svg" alt="Customer Service" />
      <div>
        <Typography variant="h6">{i18n.customer_service_title}</Typography>
        {/* <p className="text-color">{i18n.customer_service_number}</p> */}
        <p className="text-color">{i18n.customer_service_email}</p>
        <p className="text">{i18n.customer_service_time}</p>
      </div>
    </div>
  );
});
